import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useControlled } from '@costar-ui/hooks';
import React, { useState, useEffect, useCallback } from 'react';
import { getStarValues } from './get-star-values.esm.js';
import { StarRatingUI } from './star-rating-ui.esm.js';

var _excluded = ["onClick", "value"];
var maxRating = 5; //is it worth supporting anything else? no?
var defaultRating = 0;
var StarRatingFilter = function StarRatingFilter(props) {
  var onClick = props.onClick,
    value = props.value,
    rest = _objectWithoutProperties(props, _excluded);
  var _useControlled = useControlled({
      controlled: value !== null && value !== void 0 ? value : undefined,
      //pass 0 or [] if you want controlled
      "default": defaultRating,
      name: 'Rating',
      state: 'open'
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    rateState = _useControlled2[0],
    setRatingState = _useControlled2[1];
  var _useState = useState(getStarValues(rateState, maxRating)),
    _useState2 = _slicedToArray(_useState, 2),
    starValues = _useState2[0],
    setStarValues = _useState2[1];
  useEffect(function () {
    setStarValues(getStarValues(rateState, maxRating));
  }, [rateState]);
  var setHandleStarClick = useCallback(function (index) {
    return function () {
      var nextRating = Array.isArray(rateState) ? rateState.includes(index + 1) ? rateState.filter(function (i) {
        return i !== index + 1;
      }) : [].concat(_toConsumableArray(rateState), [index + 1]).sort(function (a, b) {
        return a - b;
      }) : index + 1;
      setRatingState(nextRating);
      onClick && onClick(nextRating);
    };
  }, [onClick, rateState, setRatingState]);
  return /*#__PURE__*/React.createElement(StarRatingUI, _extends({
    valueArray: starValues,
    onClick: setHandleStarClick
  }, rest));
};

export { StarRatingFilter };
//# sourceMappingURL=star-rating-filter.esm.js.map
